import React from "react";
import rsePic from '../../../assets/images/rseOriginal.png'
import classes from './rsePic.module.css';

const RSEPic = (props) => {
    return(
        <div className={classes.Pic}>
            <img src={rsePic} alt="pic"/>
        </div>
    )
}
export default RSEPic;